module.exports = __webpack_public_path__ + "static/media/02_web_website-comptoir.a40fc293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/02_web_website-comptoir.jpg
// module id = 330
// module chunks = 0